import { render, staticRenderFns } from "./UpdatePriceDialog.vue?vue&type=template&id=fc465c40&scoped=true"
import script from "./UpdatePriceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdatePriceDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UpdatePriceDialog.vue?vue&type=style&index=0&id=fc465c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc465c40",
  null
  
)

export default component.exports